export default "__VITE_ASSET__xi8_R0DZ__"